/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagecolumnbuyer3Inputs */

const en_ticketpagecolumnbuyer3 = /** @type {(inputs: Ticketpagecolumnbuyer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buyer`)
};

const de_ticketpagecolumnbuyer3 = /** @type {(inputs: Ticketpagecolumnbuyer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käufer`)
};

/**
* | output |
* | --- |
* | "Buyer" |
*
* @param {Ticketpagecolumnbuyer3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagecolumnbuyer3 = /** @type {((inputs?: Ticketpagecolumnbuyer3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagecolumnbuyer3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagecolumnbuyer3(inputs)
	return de_ticketpagecolumnbuyer3(inputs)
});
export { ticketpagecolumnbuyer3 as "ticketPageColumnBuyer" }